import DOMPurify from 'dompurify';

/**
 * Reduz HTML de rich text ao TEXTO PURO, sem nenhuma tag.
 *
 * Existe para prévias de uma linha (a "Última interação" da lista de
 * chamados): o corpo de uma mensagem pode carregar HTML do editor da casa
 * (`InputRichText`), e uma prévia não é o lugar de renderizar `<strong>` ou
 * quebras de parágrafo — é o lugar de mostrar o QUE foi dito, cru.
 *
 * `ALLOWED_TAGS: []` no DOMPurify, e não um regex de tag caseiro: o mesmo
 * motivo de `sanitizeRichText.ts` usar a biblioteca em vez de reescrever o
 * parser — HTML malformado ou aninhado quebra regex de formas sutis.
 */
export const textoPuro = (html: unknown): string => {
  if (typeof html !== 'string' || html === '') return '';

  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
};
